/**
 * Telemetry types for Application Insights integration
 */

/** Severity levels mapping to Application Insights SeverityLevel */
export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  CRITICAL = 4,
}

/** Custom properties attached to telemetry */
export interface TelemetryProperties {
  [key: string]: string | number | boolean | undefined;
}

/** User context for authenticated user telemetry */
export interface TelemetryUser {
  id: string;
  email: string;
  name: string;
  isEmbedded: boolean;
  tenant?: string;
}

/** Dependency (HTTP request) tracking data */
export interface DependencyData {
  name: string;
  url: string;
  method: string;
  duration: number;
  statusCode: number;
  success: boolean;
  properties?: TelemetryProperties;
}
